import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, take, switchMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { GuestService } from '../modules/core/services/guest.service';
import { CONSTANTS } from '../constants/constants';
import * as fromRoot from '../reducers';

export const confirmationNavigationGuard: CanActivateFn = (): Observable<boolean> => {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const guestService: GuestService = inject(GuestService);
	const router: Router = inject(Router);
	const constants: any = inject(CONSTANTS); 
	
	return store.pipe(
		select(fromRoot.getSessionState),
		filter(resData => resData.reservationRetrievalResp !== null || !!resData.error),
		take(1),
		switchMap(resData => {
			if (resData.error) {
				router.navigate([constants.ROUTES.ERROR]);
				return of(false);
			} else {
				return guestService.isArrivalInfoCompleted;
			}
		}),
		map(completed => {
			if (completed) {
				return true;
			} else {
				router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
				return false;
			}
		})
	); 
}
